import React from 'react';
import { buildWhatsAppUrl, openWhatsApp as openWhatsAppChat } from '../config/whatsapp';
import './WhatsAppFloat.css';

const WHATSAPP_CHAT_URL = buildWhatsAppUrl(
  'Hello GoToBusiness, I would like to get in touch regarding a project.'
);

const WhatsAppFloat = () => {
  const handleClick = (e) => {
    if (e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();
    openWhatsAppChat('Hello GoToBusiness, I would like to get in touch regarding a project.');
  };

  return (
    <a
      href={WHATSAPP_CHAT_URL}
      className="whatsapp-float"
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <i className="fab fa-whatsapp" aria-hidden="true" />
    </a>
  );
};

export default WhatsAppFloat;
